export { useSessionStorage } from './useSessionStorage';
//# sourceMappingURL=index.js.map